import type { StripeCustomer } from '@customerio/hydra-ui-api';
import type { PaymentCard } from '../types';

/**
 * Map a Stripe customer's saved-card fields into the shared {@link PaymentCard} shape. The Stripe
 * `card_type` is already lowercase, but normalize it anyway so every vendor's `brand` is consistent.
 */
export function stripeCustomerToPaymentCard(customer: StripeCustomer): PaymentCard {
  return {
    brand: customer.card_type.toLowerCase(),
    last4: customer.card_last4,
    expiry: customer.card_expiry,
    ownerName: customer.card_owner_name,
  };
}
